import { DriverType } from './driver-type';
import { DriverTypeSelectionItem } from "./driver-type-selection-item";
import { DriverTypeWithIndex } from './driver-type-with-index';

export class DriverTypeFilter {
    public outcome: DriverTypeSelectionItem;
}

enum SelectionState { 
    selected,
    unselected,
    mixed,
}

class FatherChildrenSelectionState {
    public father: boolean;
    public children: SelectionState;
}

export class DriverTypeFilterEditor {
    private lastClickedDriverType: DriverTypeWithIndex;
    private timer: any;

    private table: FatherChildrenSelectionState[][] = [
        [{ father: false, children: SelectionState.mixed },     { father: true,  children: SelectionState.mixed },     { father: true,  children: SelectionState.selected },  { father: true, children: SelectionState.unselected }],
        [{ father: true,  children: SelectionState.mixed },     { father: false, children: SelectionState.mixed },     { father: false, children: SelectionState.unselected },{ father: false, children: SelectionState.selected  }],
        [{ father: false, children: SelectionState.unselected },{ father: true,  children: SelectionState.unselected },{ father: true,  children: SelectionState.selected }],
        [{ father: true,  children: SelectionState.selected },  { father: false, children: SelectionState.selected },  { father: false, children: SelectionState.unselected }],
        [{ father: true,  children: SelectionState.unselected },{ father: false, children: SelectionState.unselected },{ father: false, children: SelectionState.selected }],
        [{ father: false, children: SelectionState.selected },  { father: true,  children: SelectionState.selected },  { father: true,  children: SelectionState.unselected }],
    ];
    private tableColIx = 0;
    private tableRowIx = 0;
    
    public getAllItems(filter: DriverTypeFilter): DriverTypeSelectionItem[] {
        let result : DriverTypeSelectionItem[] = [];
        result.push(filter.outcome);
        for (let i = 0; i < filter.outcome.children.length; ++i) {
            result.push(filter.outcome.children[i]);
            for (let j = 0; j < filter.outcome.children[i].children.length; ++j) {
                result.push(filter.outcome.children[i].children[j]);
            }
        }
        return result;
    }

    public setNextViewVal(filter: DriverTypeFilter, item: DriverTypeSelectionItem): void {
        let curState : FatherChildrenSelectionState;
        let nextState: FatherChildrenSelectionState;

        curState = this.getFatherChildrenViewSelectionState(item);
        if (this.lastClickedDriverType && this.lastClickedDriverType.type == item.driverTypeWithIndex.type && this.lastClickedDriverType.formulaComponentIndex == item.driverTypeWithIndex.formulaComponentIndex) {
            nextState = this.findByCurCol(curState);
        } else {
            nextState = this.findByFirstCol(curState);
        }
        item.viewSelected = nextState.father;
        let allChildren = this.getAllChildren(item);
        if (nextState.children === SelectionState.selected) {
            allChildren.forEach(function(item) {
                item.viewSelected = true;
            });
        } else if (nextState.children === SelectionState.unselected) {
            allChildren.forEach(function(item) {
                item.viewSelected = false;
            });
        }
        this.lastClickedDriverType = item.driverTypeWithIndex;

        if (this.getNumOfViewSelected(filter) === 0) {
            this.getDriverTypeSelectionItem(filter, item.driverTypeWithIndex.type, item.driverTypeWithIndex.formulaComponentIndex).viewSelected = true;
        }

        this.setManuallySelected(filter);

        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.lastClickedDriverType = undefined;
        }, 10000);
    }

    private getDriverTypeSelectionItem(filter: DriverTypeFilter, driverType: DriverType, formulaComponentIndex? : number) : DriverTypeSelectionItem {
        let all = this.getAllItems(filter);
        for (let i = 0; i < all.length; ++i) {
            if (all[i].driverTypeWithIndex.type == driverType && all[i].driverTypeWithIndex.formulaComponentIndex == formulaComponentIndex) {
                return all[i];
            }
        }
        throw `Unexpected driverType ${driverType} ${formulaComponentIndex}`;
    }

    public setNextScopeVal(filter: DriverTypeFilter, driverType: DriverType, formulaComponentIndex? : number): void {
        if (driverType == DriverType.outcome) {
            if (!filter.outcome.scopeSelected) {
                this.getAllItems(filter).forEach(x => {
                    x.scopeSelected = false;
                });
                filter.outcome.scopeSelected = true;
                filter.outcome.viewSelected = true;
            } else {
                if (!this.onlyOneScopeSelected(filter)) {
                    filter.outcome.scopeSelected = false;
                }
            }
        } else {
            for (let i = 0; i < filter.outcome.children.length; ++i) {
                let child = filter.outcome.children[i];
                if (child.driverTypeWithIndex.type == driverType && child.driverTypeWithIndex.formulaComponentIndex == formulaComponentIndex) {
                    if (!child.scopeSelected) {
                        filter.outcome.scopeSelected = false;
                        child.children.forEach(gch => {
                            gch.scopeSelected = false;
                        });
                        child.scopeSelected = true;
                        child.viewSelected = true;
                    } else {
                        if (!this.onlyOneScopeSelected(filter)) {
                            child.scopeSelected = false;
                        }
                    }
                }
                for (let j = 0; j < child.children.length; ++j) {
                    let grandChild = child.children[j];
                    if (grandChild.driverTypeWithIndex.type == driverType && grandChild.driverTypeWithIndex.formulaComponentIndex == formulaComponentIndex) {
                        if (!grandChild.scopeSelected){
                            filter.outcome.scopeSelected = false;
                            filter.outcome.children.forEach(ch => {
                                ch.scopeSelected = false;
                            });
                            grandChild.scopeSelected = true;
                            grandChild.viewSelected = true;
                        } else {
                            if (!this.onlyOneScopeSelected(filter)) {
                                grandChild.scopeSelected = false;
                            }
                        }
                    }
                }
            }
        }
        this.setManuallySelected(filter);
    }

    public selectSingleScope(filter: DriverTypeFilter, driverType: DriverType, formulaComponentIndex: number) {
        var all = this.getAllItems(filter);
        all.forEach(elem => {
            if (elem.driverTypeWithIndex.type == driverType && elem.driverTypeWithIndex.formulaComponentIndex == formulaComponentIndex) {
                elem.scopeSelected = true;
            } else {
                elem.scopeSelected = false;
            }
        });
    }

    private getFatherChildrenViewSelectionState(item: DriverTypeSelectionItem): FatherChildrenSelectionState {
        return {
            father: item.viewSelected,
            children : this.getChildrenViewSelectionState(this.getAllChildren(item)),
        };
    }

    private getAllChildren(item: DriverTypeSelectionItem): DriverTypeSelectionItem[] {
        let allChildren : DriverTypeSelectionItem[] = [];
        for (let i = 0; i < item.children.length; ++i) {
            let child = item.children[i];
            allChildren.push(child);
            for (let j = 0; j < child.children.length; ++j) {
                let grandChild = child.children[j];
                allChildren.push(grandChild);
            }
        }
        return allChildren;
    }

    private getChildrenViewSelectionState(children: DriverTypeSelectionItem[]): SelectionState {
        let hasSelected = false;
        let hasUnselected = false;
        for (let i = 0; i < children.length; ++i) {
            if(children[i].viewSelected) {
                hasSelected = true;
            } else {
                hasUnselected = true;
            }
        }
        if (hasSelected && hasUnselected) {
            return SelectionState.mixed;
        }
        if(hasSelected) {
            return SelectionState.selected;
        }
        return SelectionState.unselected;
    }

    private findByFirstCol(state: FatherChildrenSelectionState): FatherChildrenSelectionState {
        for(let i = 0; i < this.table.length; ++i) {
            if(this.table[i][0].father === state.father && this.table[i][0].children === state.children) {
                this.tableRowIx = i;
                this.tableColIx = 1;
                return this.table[i][1];
            }
        }
        throw new Error("Couldn't find state");
    }
    
    private findByCurCol(state: FatherChildrenSelectionState): FatherChildrenSelectionState {
        if(this.table[this.tableRowIx].length - 1 === this.tableColIx) {
            return this.findByFirstCol(state);
        }
        ++this.tableColIx;
        return this.table[this.tableRowIx][this.tableColIx];
    }

    public setManuallySelected(filter: DriverTypeFilter): void {
        filter.outcome.manuallySet = true;
        let allChildrenEqual = true;
        let allGrandChildrenEqual = true;
        for (let i = 0; i < filter.outcome.children.length; ++i) {
            let child = filter.outcome.children[i];
            if (filter.outcome.viewSelected != child.viewSelected) {
                allChildrenEqual = false;
            }
            for (let j = 0; j < child.children.length; ++j) {
                let grandChild = child.children[j];
                if (child.viewSelected != grandChild.viewSelected) {
                    allGrandChildrenEqual = false;
                    break;
                }
            }
        }
        for (let i = 0; i < filter.outcome.children.length; ++i) {
            let child = filter.outcome.children[i];
            child.manuallySet = !allChildrenEqual || child.scopeSelected;
            for (let j = 0; j < child.children.length; ++j) {
                let grandChild = child.children[j];
                grandChild.manuallySet = !allGrandChildrenEqual || grandChild.scopeSelected;
            }
        }
    }

    public allScopeUnselected(filter: DriverTypeFilter): boolean {
        let all = this.getAllItems(filter);
        for (let i = 0; i< all.length; ++i) {
            if (all[i].scopeSelected) {
                return false;
            }
        }
        return true;
    }

    private onlyOneScopeSelected(filter: DriverTypeFilter): boolean {
        let all = this.getAllItems(filter);
        let selectedCount = 0;
        for (let i = 0; i < all.length; ++i) {
            if (all[i].scopeSelected) {
                ++selectedCount;
            }
        }
        return selectedCount == 1;
    }
    
    private getNumOfViewSelected(filter: DriverTypeFilter): number {
        let selectedCount = filter.outcome.scopeSelected && filter.outcome.viewSelected ? 1 : 0;
        for (let i = 0; i < filter.outcome.children.length; ++i) {
            let child = filter.outcome.children[i];
            if (child.viewSelected && (child.scopeSelected || filter.outcome.scopeSelected)) {
                ++selectedCount;
            }
            for (let j = 0; j < child.children.length; ++j) {
                let grandChild = child.children[j];
                if (grandChild.viewSelected && (grandChild.scopeSelected || child.scopeSelected || filter.outcome.scopeSelected)) {
                    ++selectedCount;
                }
            }
        }
        return selectedCount;
    }
    
    public selectViewTypes(filter: DriverTypeFilter, selectedViewDriverTypes: DriverTypeWithIndex[]) {
        if (!selectedViewDriverTypes || !selectedViewDriverTypes.length) {
            return;
        }

        filter.outcome.viewSelected = selectedViewDriverTypes.find(t => t.type == DriverType.outcome) ? true : false;
        for (let i = 0; i < filter.outcome.children.length; ++i) {
            let child = filter.outcome.children[i];
            if (selectedViewDriverTypes.find(t => t.type == child.driverTypeWithIndex.type && t.formulaComponentIndex == child.driverTypeWithIndex.formulaComponentIndex)) {
                child.viewSelected = true;
            }
            for (let j = 0; j < child.children.length; ++j) {
                let grandChild = child.children[j];
                if (selectedViewDriverTypes.find(t => t.type == grandChild.driverTypeWithIndex.type && t.formulaComponentIndex == grandChild.driverTypeWithIndex.formulaComponentIndex)) {
                    grandChild.viewSelected = true;
                }
            }
        }
        this.setManuallySelected(filter);
    }
}